import React, { useEffect, useState } from "react";
import { Dots } from "./Dots";
import { useNavigate } from "react-router-dom";
import {
  Badge,
  Button,
  Modal,
  Select,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import toast from "react-hot-toast";
import NumericKeyboard from "../../components/NumericKeyboard";
import dayjs from "dayjs";
import { ApiEstadoTicket, ApiGetAllPedidosByFecha } from "../../api/tickets";
import QrReader from "../../components/qrscanner/QrReader";
import orderGif from "../../assets/order.gif";
var customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
//DD-MM-YYYY

const Recepcion = () => {
  const navigate = useNavigate();
  const dataUser = JSON.parse(localStorage.getItem("datauser"));

  const [userCode, setUserCode] = useState("");
  const [pedidos, setPedidos] = useState([]);
  const [pedidosFiltered, setPedidosFiltered] = useState([]);
  const [comidas, setComidas] = useState([]);
  const [comidaSelected, setComidaSelected] = useState("all");

  const [loading, setLoading] = useState(false);

  const [scannedResult, setScannedResult] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [pedidoAConfirmar, setPedidoAConfirmar] = useState(null);

  const [numConfirmados, setNumConfirmados] = useState(0);
  const [numPendientes, setNumPendientes] = useState(0);

  const [buttonVisible, setButtonVisible] = useState(false);

  useEffect(() => {
    if (!dataUser) {
      navigate("/auth");
    }

    if (dataUser && dataUser.roles.code !== "5") {
      navigate("/");
    }

    getPedidos();

    // Set up the interval
    const intervalId = setInterval(() => {
      getPedidos();
    }, 5000); // Refresh every 5 seconds

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    let filtered = pedidos;

    if (userCode !== "") {
      filtered = filtered.filter((pedido) =>
        pedido.pre_usuarios.code===userCode
      );
    }

    if (comidaSelected !== "all") {
      filtered = filtered.filter((pedido) => pedido.comida === comidaSelected);
    }

    setPedidosFiltered(filtered);
  }, [comidaSelected, userCode, pedidos]);

  const getPedidos = async () => {
    const fecha = dayjs().format("DD-MM-YYYY");
    let res = await ApiGetAllPedidosByFecha(fecha);
    if (res.sms === "ok") {
      const respedidos = res.pedidos.filter(
        (pedido) => pedido.client_estado === "PENDIENTE"
      );

      setNumConfirmados(res.pedidos.length - respedidos.length);
      setNumPendientes(respedidos.length);

      let comidas = respedidos.map((pedido) => pedido.comida);
      comidas = [...new Set(comidas)]; // Obtener comidas unicas

      setComidas(comidas);
      setPedidosFiltered(respedidos);
      setPedidos(respedidos);
    }
  };

  useEffect(() => {
    //1306739994 1429 SISTEMAS MANTA
    if (scannedResult && scannedResult.includes(" ")) {
      const parts = scannedResult.split(" ");
      if (parts.length > 1) {
        const c = parts[1];
        setUserCode(c);

        //halla el pedido o los pedidos que coincidan con el codigo
        const filtered = pedidos.filter((pedido) =>
          pedido.pre_usuarios.code.includes(c)
        );

        if (filtered.length === 1) {
          handleDeliveryStatus(filtered[0], true);
        }

        setScannedResult("");
      }
    }
  }, [scannedResult]);

  useEffect(() => {
    if (pedidosFiltered.length === 1 && userCode !== "") {
      setButtonVisible(true);
    } else {
      setButtonVisible(false);
    }
  }, [pedidosFiltered]);

  const handleKeyCode = (key) => {
    if (key === "enter") {
      console.log("User Code: ", userCode);
    } else if (key === "borrar") {
      setUserCode("");
    } else {
      setUserCode(userCode + key);
    }
  };

  const handleDeliveryStatus = async (pedido, qrHandle = false) => {
    //modal de confirmacion  si qrHandle es falso
    if (!qrHandle) {
      setPedidoAConfirmar(pedido);
      setShowModal(true);
      return;
    }

    setLoading(true);
    const responseEstatus = await ApiEstadoTicket({
      client_estado: "CONFIRMADO",
      pre_ticket_id: pedido.pre_ticket_id,
    });

    if (responseEstatus.sms === "ok") {
      setUserCode("");
      getPedidos();
      toast.success("Confirmado", {
        position: "bottom-right",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
    } else {
      toast.error("Error al confirmar", {
        position: "bottom-right",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    setLoading(false);
  };

  // Success scan
  const onScanSuccess = (result) => {
    setScannedResult(result?.data);
  };

  // Fail scan
  const onScanFail = (err) => {};

  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "20px 25px",
        marginTop: "20px",
      }}
    >
      <Dots
        style={{ left: 0, top: 0, position: "absolute", color: "#c6cfdd" }}
      />
      <Dots
        style={{ left: 60, top: 0, position: "absolute", color: "#c6cfdd" }}
      />
      <Dots
        style={{ left: 0, top: 140, position: "absolute", color: "#c6cfdd" }}
      />
      <Dots
        style={{ right: 0, top: 60, position: "absolute", color: "#c6cfdd" }}
      />
      <div className="position-relative z-index-1">
        {/*  <div className="bg-white shadow px-5 py-3 rounded">
          

        </div> */}
        <div
          className="bg-white shadow px-5 pb-5 rounded mt-3 d-flex flex-column"
          style={{
            minHeight: "440px",
          }}
        >
          <div className="d-flex justify-content-between align-items-center  mt-1">
            <div className="d-flex justify-content-start align-items-center align-self-center">
              <Text size="xl" fw="bold" className="mx-2">
                Pedidos de hoy
              </Text>{" "}
              (<DateHourSecondCounter />){" "}
            </div>
            <div>
              <Button
                leftIcon={<i className="fas fa-arrow-left"></i>}
                variant="outline"
                mx={4}
                onClick={() => navigate("/")}
              >
                Volver
              </Button>
              <Button
                variant="outline"
                color="red"
                leftIcon={<i className="fas fa-sign-out-alt"></i>}
                onClick={() => {
                  localStorage.removeItem("datauser");
                  localStorage.removeItem("accessTokenAdm");
                  localStorage.setItem("panel", false);
                  window.location = "/";
                }}
              >
                Salir
              </Button>
            </div>
          </div>
          <div className="d-flex justify-content-center flex-grow-1">
            <div className="w-100 d-flex flex-column w-aut">
              <div className="d-flex flex-column justify-content-center gap-2 align-items-end">
                <div className="d-flex flex-column w-100 justify-content-center align-items-center">
                  <Select
                    label="Filtrar por comida"
                    data={[
                      { value: "all", label: "Todos" },
                      ...comidas.map((comida) => ({
                        value: comida,
                        label: formatLabel(comida),
                      })),
                    ]}
                    placeholder="Selecciona una opción"
                    size="xl"
                    defaultValue="all"
                    onChange={(value) => setComidaSelected(value)}
                    className=" w-100 "
                  />
                  <div className="w-100 d-flex justify-content-center align-items-center my-2">
                    {" "}
                    <Button
                      color="orange"
                      variant="outline"
                      style={{ height: "100%" }}
                      size="xl"
                      onClick={() => {
                        console.log("Count");
                      }}
                    >
                      <span style={{ fontSize: "1.2rem" }}>
                        {numPendientes} Pendientes
                      </span>
                    </Button>
                    <Button
                      style={{ height: "100%" }}
                      className="m-2"
                      color="teal"
                      variant="outline"
                      size="xl"
                      onClick={() => {
                        console.log("Count");
                      }}
                    >
                      <span style={{ fontSize: "1.2rem" }}>
                        {numConfirmados} Confirmados
                      </span>
                    </Button>
                  </div>
                </div>{" "}
                <TextInput
                  placeholder="Digita el codigo del usuario"
                  label="Codigo del usuario"
                  size="xl"
                  value={userCode}
                  withAsterisk
                  onChange={() => {}}
                />
              </div>
              <div className="d-flex align-items-start justify-content-between my-2 gap-2">
                <Button
                  size="xl"
                  variant="default"
                  onClick={() => {
                    setUserCode((prev) => prev + "V");
                  }}
                  h={50}
                  w={90}
                  style={{
                    borderColor: "#6991cc",
                  }}
                  className="button-keyboard-numeric-animation"
                >
                  <span
                    style={{
                      fontSize: "1.5rem",
                      paddingLeft: "2px",
                      paddingRight: "2px",
                    }}
                  >
                    V
                  </span>
                </Button>
                <Button
                  size="xl"
                  variant="default"
                  onClick={() => {
                    setUserCode((prev) => prev + "P");
                  }}
                  h={50}
                  w={90}
                  style={{
                    borderColor: "#6991cc",
                  }}
                  className="button-keyboard-numeric-animation"
                >
                  <span
                    style={{
                      fontSize: "1.5rem",
                      paddingLeft: "2px",
                      paddingRight: "2px",
                    }}
                  >
                    P
                  </span>
                </Button>
                <Button
                  size="xl"
                  variant="default"
                  onClick={() => {
                    setUserCode((prev) => prev + "E");
                  }}
                  h={50}
                  w={90}
                  style={{
                    borderColor: "#6991cc",
                  }}
                  className="button-keyboard-numeric-animation"
                >
                  <span
                    style={{
                      fontSize: "1.5rem",
                      paddingLeft: "2px",
                      paddingRight: "2px",
                    }}
                  >
                    E
                  </span>
                </Button>
                <Button
                  size="xl"
                  variant="default"
                  onClick={() => {
                    setUserCode((prev) => prev + "G");
                  }}
                  h={50}
                  w={90}
                  style={{
                    borderColor: "#6991cc",
                  }}
                  className="button-keyboard-numeric-animation"
                >
                  <span
                    style={{
                      fontSize: "1.5rem",
                      paddingLeft: "2px",
                      paddingRight: "2px",
                    }}
                  >
                    G
                  </span>
                </Button>
              </div>

              <div className="flex-grow-1 d-flex align-items-stretch">
                <div
                  className="w-100 mt-3 overflow-auto rounded scrollable-div"
                  style={{
                    maxHeight: "250px",
                    border: "1px solid #c6cfdd",
                  }}
                >
                  {pedidosFiltered.length > 0 ? (
                    pedidosFiltered.map((pedido, index) => (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center border py-2 px-2 rounded shadow-sm m-2"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <span
                            className="px-3 mx-1"
                            style={{
                              backgroundColor: "#f1f1f1",
                              borderRadius: "5px",
                              fontSize: "1.5rem",
                            }}
                          >
                            {pedido.consecutivo_periodo_fecha}
                          </span>
                          <div className="d-flex flex-column align-items-start gap-1">
                            <span className="fw-bold">
                              {pedido.pre_usuarios.nombres}{" "}
                              {pedido.pre_usuarios.apellidos}
                            </span>
                            <span
                              style={{
                                margin: "0",
                                padding: "0",
                                fontWeight: "bold",
                                fontSize: "1.2rem",
                                visibility: buttonVisible
                                  ? "visible"
                                  : "hidden",
                              }}
                            >
                              <i className="fas fa-user"></i>{" "}
                              {pedido.pre_usuarios.code}
                            </span>
                            <span className="text-secondary">
                              {pedido.comida}
                            </span>
                          </div>
                        </div>
                        <button
                          className="mx-2 btn btn-secondary shadow"
                          color="teal"
                          classNames="btnconfirmar"
                          style={{
                            background: "green",
                            color: "white",
                            visibility: buttonVisible ? "visible" : "hidden",
                          }}
                          onClick={() => handleDeliveryStatus(pedido, true)}
                        >
                          <h5>Confirmar</h5>
                          <i className="fas fa-check"></i>
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <img
                        src={orderGif}
                        alt="order"
                        style={{
                          width: "100px",
                          height: "100px",
                        }}
                      />
                      <p className="text-center display-6">
                        No hay pedidos aqui
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <NumericKeyboard
              onKeyClick={handleKeyCode}
              iconReset={true}
              iconSearch={true}
              clases="w-100"
            />
          </div>
        </div>
      </div>
      <Modal
        title="Confirmar pedido"
        opened={showModal}
        onClose={() => setShowModal(false)}
        centered
      >
        <Title order={3} mb={30}>
          ¿Está seguro de confirmar este pedido a{" "}
          {pedidoAConfirmar && pedidoAConfirmar.pre_usuarios.nombres}{" "}
          {pedidoAConfirmar && pedidoAConfirmar.pre_usuarios.apellidos}?
        </Title>
        <Button
          onClick={() => {
            handleDeliveryStatus(pedidoAConfirmar, true);
            setShowModal(false);
          }}
          size="xl"
          color="teal"
          mr={20}
          disabled={loading}
          leftIcon={
            loading ? (
              <i className="fas fa-spinner fa-spin"></i>
            ) : (
              <i className="fas fa-check"></i>
            )
          }
        >
          <span
            style={{
              fontSize: "1.2rem",
            }}
          >
            {loading ? "Confirmando..." : "Confirmar"}
          </span>
        </Button>
        <Button
          size="xl"
          color="red"
          onClick={() => setShowModal(false)}
          disabled={loading}
          leftIcon={<i className="fas fa-times"></i>}
        >
          <span
            style={{
              fontSize: "1.2rem",
            }}
          >
            Cancelar
          </span>
        </Button>
      </Modal>
    </div>
  );
};

const DateHourSecondCounter = () => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="d-flex pt-4 pb-3">
      <Badge
        color="teal"
        variant="filled"
        style={{ fontSize: "1.2rem" }}
        mr={5}
      >
        {date.toLocaleDateString()}
      </Badge>
      <Badge color="teal" variant="filled" style={{ fontSize: "1.2rem" }}>
        {date.toLocaleTimeString()}
      </Badge>
    </div>
  );
};

function formatLabel(label) {
  return label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
}

export default Recepcion;
